module.exports = __webpack_public_path__ + "static/media/alter_shape_passo1.41fc2b2b.png";